import api from "services/api";

export const fetchListMajorNames = async () => {
  try {
    const res = await api.get("/ListMajorName");
    return res.data;
  } catch (err) {
    throw err;
  }
};
